import axios from 'axios';
import { store } from '../app/store/store';

const client = axios.create({
  baseURL: 'https://kopra.khs.dk:8080/api',
  headers: {
    'Content-type': 'application/json',
  },
});

/**
 * Below we can configure middleware when requests are sent or when a response is received
 */

client.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    config.headers.Authorization = store.getState().userInfo.jwtToken;
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  },
);

client.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  },
);

export default client;
